/**
 * A-15 — whether the order's **Payment proofs** panel has anything to say. Pure, so the rule can
 * be tested without rendering the screen.
 *
 * The defect: on a consigned order the panel read *"No payment proof yet — The retailer hasn't
 * submitted one against this order."* Under consignment nothing is payable at order time (SH-06,
 * D33: the goods stay Miraki's until the retailer sells them), so that sentence chases money
 * nobody owes and implies a step that does not exist. It is the retired advance model on screen.
 *
 * The panel itself is **not** retired with that model, which is why this is a predicate and not a
 * deletion:
 *
 *  - A **COURIER** proof is live money under v1.6. The payable on a Consignment Invoice is the
 *    courier charge alone (SH-13, Delivery Reconciliation Impact §5), it is submitted against the
 *    order, and this panel is where Admin verifies it. Deleting the panel would delete the only
 *    verification path for a charge the retailer really does owe.
 *  - Proofs recorded under the retired model are history and must stay readable. That is the
 *    precedent `shipment.service.ts` sets for `incoterm`: retired at v1.6, still read, still
 *    shown, and its removal belongs to the **contract** step of expand-deploy-contract — W6's
 *    work, not a screen fix's.
 *
 * So the smaller correct thing: where the portal offers consignment, the panel appears only once
 * a proof actually exists. Where it does not, the empty state still tells the truth and is kept
 * exactly as it was.
 *
 * Gated on the portal **capability**, never on `portal.code` (D46) — portals are N, not two, and
 * consignment is a capability of a portal rather than a country. The capability is still named
 * `memo` in code until it is renamed.
 */
export function showsPaymentProofs(consignment: boolean, proofCount: number): boolean {
  return !consignment || proofCount > 0;
}
